/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiTransactionSummaryByCountry } from './ApiTransactionSummaryByCountry';
import {
    ApiTransactionSummaryByCountryFromJSON,
    ApiTransactionSummaryByCountryFromJSONTyped,
    ApiTransactionSummaryByCountryToJSON,
    ApiTransactionSummaryByCountryToJSONTyped,
} from './ApiTransactionSummaryByCountry';
import type { ApiTransactionSummaryByMonth } from './ApiTransactionSummaryByMonth';
import {
    ApiTransactionSummaryByMonthFromJSON,
    ApiTransactionSummaryByMonthFromJSONTyped,
    ApiTransactionSummaryByMonthToJSON,
    ApiTransactionSummaryByMonthToJSONTyped,
} from './ApiTransactionSummaryByMonth';
import type { ApiTransactionSummaryByAccount } from './ApiTransactionSummaryByAccount';
import {
    ApiTransactionSummaryByAccountFromJSON,
    ApiTransactionSummaryByAccountFromJSONTyped,
    ApiTransactionSummaryByAccountToJSON,
    ApiTransactionSummaryByAccountToJSONTyped,
} from './ApiTransactionSummaryByAccount';

/**
 * 
 * @export
 * @interface ApiPersonTransactionsSummary
 */
export interface ApiPersonTransactionsSummary {
    /**
     * 
     * @type {boolean}
     * @memberof ApiPersonTransactionsSummary
     */
    apiDisabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ApiPersonTransactionsSummary
     */
    totalReceivedAmount: number;
    /**
     * 
     * @type {number}
     * @memberof ApiPersonTransactionsSummary
     */
    totalSentAmount: number;
    /**
     * 
     * @type {number}
     * @memberof ApiPersonTransactionsSummary
     */
    averageReceivedAmount: number;
    /**
     * 
     * @type {number}
     * @memberof ApiPersonTransactionsSummary
     */
    averageSentAmount: number;
    /**
     * 
     * @type {Date}
     * @memberof ApiPersonTransactionsSummary
     */
    firstTime?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ApiPersonTransactionsSummary
     */
    lastTime?: Date;
    /**
     * 
     * @type {number}
     * @memberof ApiPersonTransactionsSummary
     */
    totalSentAccounts: number;
    /**
     * 
     * @type {number}
     * @memberof ApiPersonTransactionsSummary
     */
    totalReceivedAccounts: number;
    /**
     * 
     * @type {Array<ApiTransactionSummaryByAccount>}
     * @memberof ApiPersonTransactionsSummary
     */
    bySent: Array<ApiTransactionSummaryByAccount>;
    /**
     * 
     * @type {Array<ApiTransactionSummaryByAccount>}
     * @memberof ApiPersonTransactionsSummary
     */
    byReceived: Array<ApiTransactionSummaryByAccount>;
    /**
     * 
     * @type {Array<ApiTransactionSummaryByMonth>}
     * @memberof ApiPersonTransactionsSummary
     */
    byMonth: Array<ApiTransactionSummaryByMonth>;
    /**
     * 
     * @type {Array<ApiTransactionSummaryByCountry>}
     * @memberof ApiPersonTransactionsSummary
     */
    byCountry: Array<ApiTransactionSummaryByCountry>;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ApiPersonTransactionsSummary
     */
    attributeMapping: { [key: string]: string; };
}

/**
 * Check if a given object implements the ApiPersonTransactionsSummary interface.
 */
export function instanceOfApiPersonTransactionsSummary(value: object): value is ApiPersonTransactionsSummary {
    if (!('totalReceivedAmount' in value) || value['totalReceivedAmount'] === undefined) return false;
    if (!('totalSentAmount' in value) || value['totalSentAmount'] === undefined) return false;
    if (!('averageReceivedAmount' in value) || value['averageReceivedAmount'] === undefined) return false;
    if (!('averageSentAmount' in value) || value['averageSentAmount'] === undefined) return false;
    if (!('totalSentAccounts' in value) || value['totalSentAccounts'] === undefined) return false;
    if (!('totalReceivedAccounts' in value) || value['totalReceivedAccounts'] === undefined) return false;
    if (!('bySent' in value) || value['bySent'] === undefined) return false;
    if (!('byReceived' in value) || value['byReceived'] === undefined) return false;
    if (!('byMonth' in value) || value['byMonth'] === undefined) return false;
    if (!('byCountry' in value) || value['byCountry'] === undefined) return false;
    if (!('attributeMapping' in value) || value['attributeMapping'] === undefined) return false;
    return true;
}

export function ApiPersonTransactionsSummaryFromJSON(json: any): ApiPersonTransactionsSummary {
    return ApiPersonTransactionsSummaryFromJSONTyped(json, false);
}

export function ApiPersonTransactionsSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiPersonTransactionsSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'apiDisabled': json['apiDisabled'] == null ? undefined : json['apiDisabled'],
        'totalReceivedAmount': json['totalReceivedAmount'],
        'totalSentAmount': json['totalSentAmount'],
        'averageReceivedAmount': json['averageReceivedAmount'],
        'averageSentAmount': json['averageSentAmount'],
        'firstTime': json['firstTime'] == null ? undefined : (new Date(json['firstTime'])),
        'lastTime': json['lastTime'] == null ? undefined : (new Date(json['lastTime'])),
        'totalSentAccounts': json['totalSentAccounts'],
        'totalReceivedAccounts': json['totalReceivedAccounts'],
        'bySent': ((json['bySent'] as Array<any>).map(ApiTransactionSummaryByAccountFromJSON)),
        'byReceived': ((json['byReceived'] as Array<any>).map(ApiTransactionSummaryByAccountFromJSON)),
        'byMonth': ((json['byMonth'] as Array<any>).map(ApiTransactionSummaryByMonthFromJSON)),
        'byCountry': ((json['byCountry'] as Array<any>).map(ApiTransactionSummaryByCountryFromJSON)),
        'attributeMapping': json['attributeMapping'],
    };
}

export function ApiPersonTransactionsSummaryToJSON(json: any): ApiPersonTransactionsSummary {
    return ApiPersonTransactionsSummaryToJSONTyped(json, false);
}

export function ApiPersonTransactionsSummaryToJSONTyped(value?: ApiPersonTransactionsSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'apiDisabled': value['apiDisabled'],
        'totalReceivedAmount': value['totalReceivedAmount'],
        'totalSentAmount': value['totalSentAmount'],
        'averageReceivedAmount': value['averageReceivedAmount'],
        'averageSentAmount': value['averageSentAmount'],
        'firstTime': value['firstTime'] == null ? value['firstTime'] : value['firstTime'].toISOString(),
        'lastTime': value['lastTime'] == null ? value['lastTime'] : value['lastTime'].toISOString(),
        'totalSentAccounts': value['totalSentAccounts'],
        'totalReceivedAccounts': value['totalReceivedAccounts'],
        'bySent': ((value['bySent'] as Array<any>).map(ApiTransactionSummaryByAccountToJSON)),
        'byReceived': ((value['byReceived'] as Array<any>).map(ApiTransactionSummaryByAccountToJSON)),
        'byMonth': ((value['byMonth'] as Array<any>).map(ApiTransactionSummaryByMonthToJSON)),
        'byCountry': ((value['byCountry'] as Array<any>).map(ApiTransactionSummaryByCountryToJSON)),
        'attributeMapping': value['attributeMapping'],
    };
}

